"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isType = exports.castType = exports.assertType = void 0;
const joi_1 = __importDefault(require("joi"));
const options = {
    allowUnknown: true,
    presence: 'required',
    convert: false // never try to convert
};
/**
 * Asserts if a given value is of type or throws an exception
 */
function assertType(val, schema, message) {
    (Array.isArray(val) ? val : [val]).every(item => message ? joi_1.default.assert(item, schema, message, options) : joi_1.default.assert(item, schema, options));
}
exports.assertType = assertType;
/**
 * Narrows type if a given value is of type or throws an exception
 */
function castType(val, schema, message) {
    assertType(val, schema, message);
    return val;
}
exports.castType = castType;
/**
 * Returns true if a given value is of type
 */
function isType(val, schema, message) {
    return (Array.isArray(val) ? val : [val]).every(item => message ? joi_1.default.attempt(item, schema, message, options) : joi_1.default.attempt(item, schema, options));
}
exports.isType = isType;
//# sourceMappingURL=assertions.js.map